export default function Login() {
  return (
    <div className="flex items-center justify-center h-screen bg-black text-white">
      <div className="bg-white/10 p-10 rounded-2xl backdrop-blur-lg w-96">
        <h2 className="text-3xl mb-6 text-center">Login</h2>

        <input placeholder="Email" className="w-full mb-4 p-3 rounded text-black" />
        <input placeholder="Password" type="password" className="w-full mb-6 p-3 rounded text-black" />

        <button className="bg-blue-500 w-full py-3 rounded-xl">
          Login
        </button>
      </div>
    </div>
  );
}